<template>
  <div class="page">
    <steps direction="vertical" :active="active">
      <step v-for="paper in papers" :key="paper.id">
        <h3>{{ paper.title }}</h3>
        <p v-html="paper.notice"></p>
      </step>
    </steps>

    <div class="footer">
      <vant-button round block color="#315ace" @click="toReport" v-if="overIds.length == papers.length">谢谢答题</vant-button>
      <vant-button round block color="#315ace" @click="toGoOn" v-else>继续答题</vant-button>
    </div>
  </div>

</template>
<script>
import { getPaperInfo, getPaperOverIds } from "@api/eval";
import { Steps, Step, Button as VantButton } from "vant";

export default {
  components: {
    Steps, Step,VantButton
  },
  data: function() {
    return {
      projectId: this.$route.params.projectId,
      papers: [],
      overIds: [],
    }
  },
  created() {
    this.init();
  },
  computed: {
    active(){
      let idx = this.overIds.length -1
      return idx<0 ? 0 : idx;
    }
  },
  methods: {
    init() {
      this.fetchOverIds()
      this.fetchPapers()
    },
    fetchPapers() {
      getPaperInfo(this.projectId).then(res => {
        this.papers = res.result || [];
      });
    },
    fetchOverIds() {
      getPaperOverIds(this.projectId).then(res => {
        this.overIds = res.result || [];
      });
    },
    toReport() {
      this.$router.replace({ path: `/eval/result/${this.projectId}` });
    },
    toGoOn() {
      this.$router.replace({ path: `/eval/start/${this.projectId}` });
    }
  }
};
</script>
<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #F5F5F5;

  .footer {
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    padding: 10px 30px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }
}
</style>
